import React from 'react';

export const WarningCircle = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.25 12C20.25 7.44329 16.5567 3.75 12 3.75C7.44329 3.75 3.75 7.44329 3.75 12C3.75 16.5557 7.44335 20.25 12 20.25C16.5566 20.25 20.25 16.5557 20.25 12ZM21.75 12C21.75 17.3841 17.3852 21.75 12 21.75C6.61481 21.75 2.25 17.3841 2.25 12C2.25 6.61487 6.61487 2.25 12 2.25C17.3851 2.25 21.75 6.61487 21.75 12Z"
      fill="#64748B"
    />
    <path
      d="M11.25 15.7422V15.6943C11.25 15.2801 11.5858 14.9443 12 14.9443C12.4142 14.9444 12.75 15.2802 12.75 15.6943V15.7422C12.7498 16.1562 12.414 16.4921 12 16.4922C11.5859 16.4922 11.2502 16.1562 11.25 15.7422ZM11.2461 12.6064V8.30664C11.2461 7.89243 11.5819 7.55664 11.9961 7.55664C12.4103 7.55664 12.7461 7.89243 12.7461 8.30664V12.6064L12.7422 12.6826C12.7039 13.0609 12.3845 13.3564 11.9961 13.3564C11.6077 13.3564 11.2883 13.0609 11.25 12.6826L11.2461 12.6064Z"
      fill="#64748B"
    />
  </svg>
);
